import {PROBE_ROW_COUNTS} from './probeRowCounts';

export const EMPTY_SECTION_HEIGHTS = PROBE_ROW_COUNTS.map(() => null);
